import { render, staticRenderFns } from "./AVehicleAppointment.vue?vue&type=template&id=92fbd1ec&scoped=true"
import script from "./AVehicleAppointment.vue?vue&type=script&lang=js"
export * from "./AVehicleAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fbd1ec",
  null
  
)

export default component.exports